// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import VueMaterial from 'vue-material'
import {MdField} from 'vue-material/dist/components'
import VueMask from 'v-mask'
import AlertAlert from 'vue-alert-alert'
import 'vue-material/dist/vue-material.min.css'

import * as Cookies from 'js-cookie'

import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faCheck,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faBars,
  faLightbulb,
  faTimes,
  faCheckCircle,
  faExclamation,
  faClipboard,
} from '@fortawesome/free-solid-svg-icons'
import {faQuestionCircle} from '@fortawesome/free-regular-svg-icons'
import {
  faCcAmex,
  faCcVisa,
  faCcDiscover,
  faCcMastercard,
} from '@fortawesome/free-brands-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import 'materialize-css'
import pluralize from 'pluralize'
import {customVariableValue, customVariablesFilter} from '@/services/organizationCustomVariables'
import GetTextPlugin from 'vue-gettext'
import translations from '@/locales/translations.json'
import Hotjar from 'vue-hotjar'
import Rollbar from 'rollbar'
import axios from 'axios'
import { setupCache } from 'axios-cache-adapter'
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'

import {fas} from '@fortawesome/free-solid-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
library.add(far)

const domain = /:\/\/([^\/]+)/.exec(window.location.href)[1]
const subdomain = domain.split('.')[0]

axios.interceptors.response.use(function (response) {
  if (!Cookies.get('sessionId')) {
    const newSessionId = Math.random().toString(32)
    const sessionId = response.headers['x-grant-circles-session-id'] || newSessionId
    Cookies.set('sessionId', sessionId, {expires: 14})
  }

  if (
    Cookies.get('sessionId') &&
    response.headers['x-grant-circles-session-id'] &&
    Cookies.get('sessionId') != response.headers['x-grant-circles-session-id']
  ) {
    Cookies.set('sessionId', response.headers['x-grant-circles-session-id'], {expires: 14})
  }

  if (!Cookies.get('agent')) {
    Cookies.set('agent', response.headers['x-grant-circles-agent'] || '{}', {
      expires: 14,
    })
  }

  if (
    Cookies.get('agent') &&
    response.headers['x-grant-circles-agent'] &&
    Cookies.get('agent') != response.headers['x-grant-circles-agent']
  ) {
    Cookies.set('agent', response.headers['x-grant-circles-agent'] || '{}', {
      expires: 14,
    })
  }

  return response
})

axios.interceptors.request.use(function (config) {
  config.headers['X-Grant-Circles-Session-Id'] = Cookies.get('sessionId')
  config.headers['X-Grant-Circles-Agent'] = Cookies.get('agent') || '{}'
  return config
})

// EXP and RED Staging environments need to match an organization
// in the database, since they are hosted at different subdomains.
const StagingOrgSelectors = {
  'abc-company-exp': 'abc-company-staging',
  'staff-exp': 'staff-staging',
  'abc-company-red': 'abc-company-staging',
  'staff-red': 'staff-staging',
}
const masqueradeOrg = StagingOrgSelectors[subdomain]

axios.defaults.headers.common['X-Grant-Circles-Subdomain'] = masqueradeOrg
  ? masqueradeOrg
  : subdomain

axios.defaults.headers.common['X-CSRFToken'] = Cookies.get('csrftoken')
axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true'
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT

const cache = setupCache({
  // 2 minute cache timeout
  maxAge: 2 * 60 * 1000,
  // Build the cache key off the URL and serialized parameters, if they exist
  key: req => req.params ? req.url + Object.keys(req.params).map(key => key + '=' + req.params[key]).join('&') : req.url,
  // Ignore caching headers
  readHeaders: false,
  // Don't exclude queries
  exclude: { query: false },
  // Invalidate requests
  invalidate: async (config, request) => {
    if (store.state.invalidateAxiosApi) {
      store.state.invalidateAxiosApi = false
      await config.store.removeItem(config.uuid)
    }

    if (request.clearCacheEntry) {
      await config.store.removeItem(config.uuid)
    }
  },
})
const axiosApi = axios.create({
  adapter: cache.adapter
})
store.dispatch('updateAxiosApi', axiosApi)

library.add(
  faCheck,
  faChevronRight,
  faChevronLeft,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faBars,
  faLightbulb,
  faTimes,
  faCheckCircle,
  faExclamation,
  faClipboard,
  faQuestionCircle,
)

import Vuex from 'vuex'
import VueGtag from 'vue-gtag'

import utils from '@/services/utils'

import router from './router'
import store from './store'
import App from './App'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)
const vuetify = new Vuetify({})
Vue.use(GetTextPlugin, {
  translations,
  availableLanguages: {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    pt: 'Português',
  },
  defaultLanguage: 'en',
})

library.add(
  faCheck,
  faChevronRight,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faCcAmex,
  faCcVisa,
  faCcDiscover,
  faCcMastercard,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.use(Vuex)
Vue.use(VueMeta)
Vue.use(VueMaterial)
Vue.use(AlertAlert)
Vue.use(Datetime)
Vue.use(VueMask)
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      send_page_view: false,
    },
  },
})
if (process.env.VUE_APP_HOTJAR_ID) {
  Vue.use(Hotjar, {
    id: process.env.VUE_APP_HOTJAR_ID,
    isProduction: process.env.VUE_APP_PRODUCTION === 'true',
  })
}

if (process.env.VUE_APP_PRODUCTION === 'true') {
  Vue.prototype.$rollbar = new Rollbar({
    accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
  })
}

Vue.component(
  'MdSelect',
  Vue.options.components.MdSelect.extend({
    methods: {
      isInvalidValue: function isInvalidValue() {
        return this.$el.validity
          ? this.$el.validity.badInput
          : this.$el.querySelector('input').validity.badInput
      },
    },
  }),
)

Vue.filter('currency', num => utils.formatNumberAsUSD(num, false))
Vue.filter('currencyDollars', num => utils.formatNumberAsUSD(num, true))

Vue.filter('formatDateShort', utils.formatDateShort)
Vue.filter('formatDateLong', utils.formatDateLong)
Vue.filter('formatDateTimeZone', utils.formatDateTimeZone)
Vue.filter('datePickerFormat', utils.datePickerFormat)
Vue.filter('translateToCurrentLang', utils.translateToCurrentLang)
Vue.filter('pluralize', function (value, number) {
  return pluralize(value, number)
})
Vue.filter('customVariablesFilter', customVariablesFilter)
Vue.filter('customVariableValue', customVariableValue)
Vue.filter('debugLang', utils.debugLang)

Vue.config.errorHandler = (error, vm, info) => {
  if (
    axios.isAxiosError(error) &&
    error.response.status == 401 &&
    error.response.statusText == 'Unauthorized'
  ) {
    // Always reset state so the token is gone when we attempt to submit the survey.
    store.commit('RESET_STATE')

    if (!window.location.pathname.split('/').includes('survey-responses')) {
      vm.$router.push({name: 'Home'})
    }
  }

  if (axios.isAxiosError(error) && error.response.status >= 500) {
    vm.$set(vm.$root.$children[0], 'apiError', true)
  }
  if (vm.$rollbar) {
    vm.$rollbar.error(error)
  }
  throw error
}

/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  store,
  router,
  vuetify,
  template: '<App/>',
  components: {App},
})

// Pass the $language service to the store
store.$language = vm.$language
store.commit('UPDATE_CURRENT_LANGUAGE', store.state.currentLanguage)

// token is null if it doesn't exist, but this hydrates the store from
// localstorage when we spin up the application.
store.commit('UPDATE_USERTOKEN', window.localStorage.getItem('token'))
